(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.DSDOriginalsPolishCore = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var SPEEDS = [1, 1.25, 1.5, 1.75, 2];
  var QUICK_FILTERS = ['all', 'available', 'saved', 'in_progress'];

  function text(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function normalizeList(value) {
    if (Array.isArray(value)) return value.map(text).filter(Boolean);
    return text(value).split(',').map(function (item) { return item.trim(); }).filter(Boolean);
  }

  function normalizeSelection(value) {
    var values = Array.isArray(value) ? value.slice(0, 32) : String(value == null ? '' : value).slice(0, 2560).split(',').slice(0, 32);
    return values.map(function (item) { return text(item).slice(0, 80); }).filter(Boolean);
  }

  function localStorageScope(config) {
    if (!config || !config.signedIn) return 'device-guest';
    return /^[a-f0-9]{64}$/.test(String(config.userScope || '')) ? config.userScope : null;
  }

  function normalizeDiscovery(input) {
    input = input || {};
    var quick = QUICK_FILTERS.includes(input.quick) ? input.quick : 'all';
    var sort = ['title', 'published', 'updated', 'recently_played'].includes(input.sort) ? input.sort : 'title';
    return {
      query: text(String(input.query == null ? '' : input.query).slice(0, 120)),
      quick: quick,
      sort: sort,
      access: normalizeSelection(input.access),
      formats: normalizeSelection(input.formats),
      tags: normalizeSelection(input.tags),
      progress: normalizeSelection(input.progress),
      releaseState: normalizeSelection(input.releaseState),
      durations: normalizeSelection(input.durations)
    };
  }

  function durationBucket(seconds) {
    var minutes = Math.max(0, Number(seconds) || 0) / 60;
    if (minutes < 10) return 'under_10';
    if (minutes < 20) return '10_20';
    if (minutes < 40) return '20_40';
    return '40_plus';
  }

  function intersects(selected, actual) {
    if (!selected.length) return true;
    return selected.some(function (item) { return actual.includes(item); });
  }

  function matches(item, rawState) {
    var state = normalizeDiscovery(rawState);
    var haystack = [item.title, item.summary, item.chapterTitles, item.tags].flat().map(text).join(' ');
    if (state.query && !haystack.includes(state.query)) return false;
    if (state.quick === 'available' && !item.available) return false;
    if (state.quick === 'saved' && !item.saved) return false;
    if (state.quick === 'in_progress' && item.progress !== 'in_progress') return false;
    if (!intersects(state.access, normalizeList(item.access))) return false;
    if (!intersects(state.formats, normalizeList(item.formats))) return false;
    if (!intersects(state.tags, normalizeList(item.tags))) return false;
    if (!intersects(state.progress, normalizeList(item.progress))) return false;
    if (!intersects(state.releaseState, normalizeList(item.releaseState))) return false;
    var chapterDurations = Array.isArray(item.chapterDurationsSeconds)
      ? item.chapterDurationsSeconds : [item.durationSeconds];
    var durationBands = chapterDurations.filter(function (seconds) {
      return typeof seconds === 'number' && Number.isFinite(seconds) && seconds > 0;
    }).map(durationBucket);
    if (!intersects(state.durations, durationBands)) return false;
    return true;
  }

  function activeFilterCount(rawState) {
    var state = normalizeDiscovery(rawState);
    return ['access', 'formats', 'tags', 'progress', 'releaseState', 'durations'].reduce(function (count, key) {
      return count + state[key].length;
    }, state.quick === 'all' ? 0 : 1);
  }

  function normalizeReaderPreferences(input) {
    input = input || {};
    var size = Math.round(Number(input.size) || 20);
    var speed = Number(input.speed);
    return {
      size: Math.min(28, Math.max(18, size)),
      font: input.font === 'plain' ? 'plain' : 'serif',
      spacing: ['compact', 'comfortable', 'airy'].includes(input.spacing) ? input.spacing : 'comfortable',
      focus: Boolean(input.focus),
      reducedMotion: Boolean(input.reducedMotion),
      speed: SPEEDS.includes(speed) ? speed : 1
    };
  }

  function remainingSeconds(duration, currentTime, speed) {
    var safeSpeed = SPEEDS.includes(Number(speed)) ? Number(speed) : 1;
    return Math.max(0, (Number(duration) - Number(currentTime)) / safeSpeed);
  }

  return {
    SPEEDS: SPEEDS.slice(),
    QUICK_FILTERS: QUICK_FILTERS.slice(),
    normalizeDiscovery: normalizeDiscovery,
    localStorageScope: localStorageScope,
    durationBucket: durationBucket,
    matches: matches,
    activeFilterCount: activeFilterCount,
    normalizeReaderPreferences: normalizeReaderPreferences,
    remainingSeconds: remainingSeconds
  };
});
